import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import { useEntityReferenceSelect } from "@/hooks/use-entity-reference-options.hook.ts";
import { CustomFieldSelect } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";

/** Ссылка на справочник Skailer: опции и поиск — те же хуки, что у системных полей должности. */
export function CustomFieldEditEntityReference(props: CustomFieldRendererProps) {
  const { field, form, fieldValue } = props;
  const selectedValue: unknown = useWatch({ control: form.control, name: field.slug });
  const selectedIds = useMemo(
    () =>
      Array.isArray(selectedValue)
        ? selectedValue.filter((id): id is number => typeof id === "number")
        : [],
    [selectedValue]
  );
  const selectedReferences = useMemo(
    () => fieldValue?.value_references ?? field.default_value?.value_references ?? [],
    [fieldValue?.value_references, field.default_value?.value_references]
  );
  const selectProps = useEntityReferenceSelect(
    field.reference_entity,
    selectedIds,
    selectedReferences,
    !props.readOnly
  );

  return <CustomFieldSelect {...props} {...selectProps} />;
}
